import React, { FunctionComponent } from "react";

import {
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../../../constants/partTypes";
import {
  AnyOrderItem,
  OrderItemAccessory,
  OrderItemPackage,
  OrderItemTire,
  OrderItemWheel,
} from "../../../stores/slices/cartSlice";
import { CartPrintItemAccessory } from "./Tiles/CartPrintItemAccessory";
import { CartPrintItemPackage } from "./Tiles/CartPrintItemPackage";
import { CartPrintItemTire } from "./Tiles/CartPrintItemTire";
import { CartPrintItemWheel } from "./Tiles/CartPrintItemWheel";

type CartPrintOrderItemProps = {
  orderItem: AnyOrderItem;
};

export const CartPrintOrderItem: FunctionComponent<CartPrintOrderItemProps> = ({
  orderItem,
}) => {
  switch (orderItem.itemType) {
    case partTypeTire:
      return <CartPrintItemTire orderItem={orderItem as OrderItemTire} />;
    case partTypeWheel:
      return <CartPrintItemWheel orderItem={orderItem as OrderItemWheel} />;
    case partTypePackage:
      return <CartPrintItemPackage orderItem={orderItem as OrderItemPackage} />;
    case partTypeAccessory:
      return (
        <CartPrintItemAccessory orderItem={orderItem as OrderItemAccessory} />
      );
  }
};
